import { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { useModalV2 } from 'common/modal/hooks/useModalV2';
import { modalV2Atom } from 'common/modal/stores/atom';

export const useSearchTimeoutAlert = () => {
  const { openModal } = useModalV2();
  const modalState = useRecoilValue(modalV2Atom);
  const pendingResolveRef = useRef<((value: boolean) => void) | null>(null);

  // Treat any modal close (button, backdrop, escape) we did not handle
  // as dismissal so the awaiting search never hangs.
  useEffect(() => {
    if (!modalState.isOpen && pendingResolveRef.current) {
      const resolve = pendingResolveRef.current;
      pendingResolveRef.current = null;
      resolve(false);
    }
  }, [modalState.isOpen]);

  const showSearchTimeoutAlert = (): Promise<boolean> =>
    new Promise((resolve) => {
      const settle = (value: boolean) => {
        if (pendingResolveRef.current !== resolve) return;
        pendingResolveRef.current = null;
        resolve(value);
      };

      pendingResolveRef.current = resolve;

      openModal({
        title: 'Search timed out',
        subtitle: 'Sorry, that took longer than expected.',
        primaryButtonText: 'Try again',
        secondaryButtonProps: { hidden: true },
        onPrimaryAction: () => settle(true)
      });
    });

  return { showSearchTimeoutAlert };
};
